// Change button text everytime easygift updates the button
const easygiftButtonObserver = new MutationObserver(function(mutations_list) {
	mutations_list.forEach(function(mutation) {
      if(mutation.target.textContent === 'Select'){   
		// Change button text
        modifyBtnText();
      }
	});
});

// Customize easygift modal when modal is in the dom or open
const easygiftObserver = new MutationObserver(function(mutations_list) {
	mutations_list.forEach(function(mutation) {
		mutation.addedNodes.forEach(function(added_node) {
			if(added_node.id == 'aca-modal') {
                easygiftButtonObserver.observe(document.querySelector(".aca-product-button"),  { subtree: false, childList: true });
				customizeModal()
				// easygiftObserver.disconnect();
			}
		});
	});
});

const modifyBtnText = () => {
  const buttonEl = document.querySelector(".aca-product-button");
  const body = document.querySelector('body');
  if(!buttonEl.classList.contains('aca-product-out-of-stock-button')){
    if(body.id.includes('kpop-demon-hunters-flask-sling')){
      buttonEl.innerHTML = "Add to bag";  
    } else if(body.id.includes('kpop-demon-hunters-lunch-pack')){
      buttonEl.innerHTML = "Add to bag";  
    } else {
      buttonEl.innerHTML = "Add to bag";  
    }
  }
}

const customizeModal = () => {

  //Change product title
  const body = document.querySelector('body');
  const productTitleEl = document.querySelector(".aca-product-name");
  const kdphSlingCopy = "Get the KPop Demon Hunters Flask Sling with the Pod for <s>P1,690</s> P1,590."
  const kdphLunchPackCopy = `Get the KPop Demon Hunters Lunch pack with the Name Tag for <s>P1,890</s> P1,790.`
  const bubbleCapSetCopy = `Please select your Band color`
  const newProductTitle = `Congrats! ✨ You got a free<br> ${productTitleEl.textContent}.`

  if(body.id.includes('kpop-demon-hunters-flask-sling')){
    productTitleEl.innerHTML = kdphSlingCopy;
  } else if(body.id.includes('kpop-demon-hunters-lunch-pack')){
    productTitleEl.innerHTML = kdphLunchPackCopy;
  } else if(body.id.includes('bubble-cap-set')){
    productTitleEl.innerHTML = bubbleCapSetCopy;
  } else {
    if(productTitleEl.textContent.includes('Pod')){
      productTitleEl.innerHTML = kdphSlingCopy;
    }else if(productTitleEl.textContent.includes('Name Tag')){
      productTitleEl.innerHTML = kdphLunchPackCopy;
    }else
      productTitleEl.innerHTML = newProductTitle;
  }

  //Add selector label
  const label = document.createElement('label')
  label.innerHTML = 'Pick a color:'
  const parentEl = document.querySelector('.aca-product')
  parentEl.insertBefore(label, document.querySelector('.aca-product-dropdown'))

  //Change button text
  modifyBtnText();

  const variantSelector = document.querySelector('.aca-product-variants').addEventListener('change',() => {
    //Change button text
    modifyBtnText();
  })

}
easygiftObserver.observe(document.querySelector("body"), { subtree: false, childList: true });

